import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Styles } from './TableStyling';
import TableFunction from './TableFunction';
import { pushShowRecommendationTab } from '../../../slices/recommendationTableSlice';
import { pushPolicyData, pushImpactResultData } from '../../../slices/AccordionDataSlice';
import { pushRecommendationData } from '../../../slices/RecommendationDataSlice';
import { withRouter } from 'react-router-dom';
import { pushDetailsPageStatusCardData } from '../../../slices/DetailsPageStatusCardSlice';
import { pushRiskScoreCardData } from '../../../slices/RiskScoreCardSlice';
import { Pagination } from '../Pagination/Pagination';
import { pushInitialLimit, pushInitialOffset, pushRecoSortBy } from '../../../slices/RiskFilterSlice';
import { getPostResponseAPIData } from '../../../services/apiservices';
import { recommendationUrl } from '../../../constants/constants';
import { pushSelectedRow } from '../../../slices/ResourceDistributionSlice';
import { baseUrlWatch } from '../../../constants/constants';
import { pushShowSpinner } from '../../../slices/SpinnerSlice';
import CircularProgress from '@material-ui/core/CircularProgress';
import styled from 'styled-components';
import startCase from 'lodash/startCase';
import camelCase from 'lodash/camelCase';
export const StyledSpinnerDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 350px;
`;
export const StyledDataDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 350px;
  background: rgba(235, 237, 239, 0.4);
`;

const RecommendationTable = props => {
  const filterRecoMandatioData = useSelector(state => state.recommendationTable.recoOriginFilter);
  const envClickEvent = useSelector(state => state.applicationDrillHeatMap.envClickEvent);
  const clickEvent = useSelector(state => state.applicationDrillHeatMap.clickEvent);
  const tableData = useSelector(state => state.recommendationTable.tableData);
  const applyEvent = useSelector(state => state.riskFilterSlice.applyEvent);
  const {
    data = {}
  } = applyEvent ? filterRecoMandatioData || {} : props.nextTableData || {};
  const {
    pageNumber = 0,
    totalElements = 0
  } = data || {};
  const {
    pageSize = 10
  } = data || {};
  const dispatch = useDispatch();
  let defaultSortValue = envClickEvent ? 'entityRiskScore' : clickEvent ? 'accountRiskScore' : 'originRiskScore';
  const [recoPageNumber, setRecoPageNumber] = React.useState(0);
  const [recoRowsPerPage, setRecoRowsPerPage] = React.useState(10);
  const [recoFilterTableSortOrder, setRecoFilterTableSortOrder] = React.useState('DSC');
  const [recoFilterTableSortOrderBy, setRecoFilterTableSortOrderBy] = React.useState(defaultSortValue);
  const recoReqBody = useSelector(state => state.riskFilterSlice.recoReqBody);
  const spinnerStatus = useSelector(state => state.spinner.loading);
  const apiResponseData = useSelector(state => state.recommendationTable.AccountResponse);
  let recommendationColumnData = [];

  if (props && props.pageType) {
    switch (props.pageType) {
      case 'application':
        recommendationColumnData = useSelector(state => state.recommendationTable.recommendationColumnData) || [];
        break;

      case 'environment':
        recommendationColumnData = useSelector(state => state.recommendationTable.recommendationApplicationColumnData) || [];
        break;

      case 'entity':
        recommendationColumnData = useSelector(state => state.recommendationTable.recommendationEnvironmentColumnData) || [];
        break;

      default:
        break;
    }
  }

  const handleChangePage = (event, newPage) => {
    if (applyEvent) {
      setRecoPageNumber(newPage);
      dispatch(pushInitialOffset(newPage));
    } else {
      props.setPage(newPage);
    }
  };

  const handleChangeRowsPerPage = event => {
    if (applyEvent) {
      dispatch(pushInitialOffset(0));
      dispatch(pushInitialLimit(parseInt(event.target.value, 10)));
      setRecoPageNumber(0);
      setRecoRowsPerPage(parseInt(event.target.value, 10));
    } else {
      props.setPage(0);
      props.setRowsPerPage(parseInt(event.target.value, 10));
    }
  };

  const showRecommendationTab = useSelector(state => state.recommendationTable.showRecommendationTab);
  const riskApiResponseData = useSelector(state => state.recommendationTable.riskResponse);

  const handleRequestRecoSort = property => {
    if (applyEvent) {
      const isDsc = recoFilterTableSortOrderBy === property && recoFilterTableSortOrder === 'DSC';
      let sortStringOrder = isDsc ? 'ASC' : 'DSC';
      let sortString = property + ':' + sortStringOrder;
      dispatch(pushRecoSortBy(sortString));
      setRecoFilterTableSortOrder(isDsc ? 'ASC' : 'DSC');
      setRecoFilterTableSortOrderBy(property);
    } else {
      props.handleRequestSort(property);
    }
  };

  let rowDataForWatch = {};

  const handleSelectedWatchFlag = (event, targetColum) => {
    dispatch(pushShowSpinner(true));
    event.stopPropagation();
    let rowData = targetColum.row.original;
    let statusVariable;

    if (rowData.underWatch === 0) {
      statusVariable = 1;
    } else {
      statusVariable = 0;
    }

    rowDataForWatch['accountId'] = rowData['accountId'];
    rowDataForWatch['appId'] = rowData['appId'];
    rowDataForWatch['id'] = '';
    rowDataForWatch['isFollowed'] = statusVariable;
    rowDataForWatch['objectArn'] = rowData['objectArn'];
    rowDataForWatch['objectName'] = rowData['objectName'];
    rowDataForWatch['objectType'] = rowData['objectType'];
    rowDataForWatch['orgId'] = rowData['orgId'];
    rowDataForWatch['origin'] = rowData['appType'];
    rowDataForWatch['tenantId'] = rowData['tenantId'];
    dispatch(getPostResponseAPIData(baseUrlWatch, 'WatchResponseData', rowDataForWatch));
  };

  const handleViewDetail = targetColum => {
    let overallRiskCategory = '';
    let overallRiskScore = '';
    let resultriskApiResponseData = [];
    let rowData = targetColum.row.original;

    if (riskApiResponseData && riskApiResponseData.data) {
      resultriskApiResponseData = riskApiResponseData.data.responseList.filter(Application => {
        return Application.origin === rowData.appName;
      });
    }

    overallRiskScore = resultriskApiResponseData && resultriskApiResponseData.length > 0 ? resultriskApiResponseData[0].overallRiskScore : 0;
    overallRiskCategory = resultriskApiResponseData && resultriskApiResponseData.length > 0 ? resultriskApiResponseData[0].overallRiskCategory : 0;
    let appName = rowData.appName;
    let envName = rowData.envName;
    let originRiskScore = rowData.originRiskScore;
    let originRiskCategory = rowData.originRiskCategory;
    let accountRiskCategory = rowData.accountRiskCategory;
    let accountRiskScore = rowData.accountRiskScore;
    let accountId = rowData.accountUuid;
    let entityUuid = rowData.entityUuid;
    let appId = rowData.appId;
    props.history.push(`/analytics/details/${appId}/${entityUuid}/${accountId}`);
    let statusCardObj = {
      origin: appName,
      envName: envName,
      overallRiskScore: overallRiskScore,
      overallRiskCategory: overallRiskCategory,
      originRiskCategory: originRiskCategory,
      originRiskScore: originRiskScore,
      accountRiskCategory: accountRiskCategory,
      accountRiskScore: accountRiskScore
    };
    dispatch(pushShowRecommendationTab(!showRecommendationTab));
    dispatch(pushImpactResultData(rowData.impactResult));
    dispatch(pushPolicyData(rowData));
    dispatch(pushRecommendationData(rowData));
    dispatch(pushSelectedRow(rowData));
    dispatch(pushDetailsPageStatusCardData(statusCardObj));
    dispatch(pushRiskScoreCardData(statusCardObj));
  };

  const processColumns = (results = []) => {
    let cols = [];

    if (results.length > 0) {
      results.forEach(key => {
        let isHidden = key.accessor === 'underWatch'; // Default Ids should be hidden

        let isRecommendation = key.accessor === 'impactResult';
        cols.push({
          align: isHidden ? 'center' : 'left',
          hidden: key['hidden'],
          Header: isHidden ? '' : isRecommendation ? 'Recommendation' : startCase(camelCase(key['Header'])),
          accessor: key['accessor'],
          width: isHidden ? 40 : isRecommendation ? 190 : Math.min(400, startCase(camelCase(key['Header'])).length * 10),
          opacity: '87%'
        });
      });
    }

    return cols;
  };

  const generateData = () => {
    let columns = processColumns(recommendationColumnData);
    let rows = [];

    if (tableData && tableData.length > 0) {
      const newTable = tableData.map(row => {
        let newObj = '';

        if (row.objectType === 'UserAccount') {
          newObj = Object.assign({}, row, {
            objectType: 'User Account'
          });
        } else {
          newObj = row;
        }

        return newObj;
      });
      rows = newTable.map(row => {
        return row;
      });
    }

    return {
      rows,
      columns
    };
  };

  let resultColums = generateData().columns;
  useEffect(() => {
    if (applyEvent) {
      dispatch(pushShowSpinner(true));
      dispatch(getPostResponseAPIData(recommendationUrl, 'recoOriginFilter', recoReqBody));
    }
  }, [recoPageNumber, recoRowsPerPage, recoFilterTableSortOrder, recoFilterTableSortOrderBy, props.watch]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, spinnerStatus || apiResponseData?.isLoading ? /*#__PURE__*/React.createElement(StyledSpinnerDiv, null, /*#__PURE__*/React.createElement(CircularProgress, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, generateData().rows.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Styles, null, /*#__PURE__*/React.createElement(TableFunction, {
    columns: resultColums,
    data: generateData().rows,
    "min-width": "30px",
    handleRequestSort: handleRequestRecoSort,
    sortOrder: applyEvent ? recoFilterTableSortOrder : props.order,
    sortOrderBy: applyEvent ? recoFilterTableSortOrderBy : props.orderBy,
    handleViewDetail: handleViewDetail,
    handleSelectedWatchFlag: handleSelectedWatchFlag,
    spinnerStatus: spinnerStatus,
    handleRecoEnvSortString: handleRequestRecoSort
  })), /*#__PURE__*/React.createElement(Pagination, {
    handleChangePage: handleChangePage,
    handleChangeRowsPerPage: handleChangeRowsPerPage,
    pageNumber: pageNumber,
    totalElements: totalElements,
    rowsPerEachPage: pageSize
  })) : /*#__PURE__*/React.createElement(StyledDataDiv, null, "No Data !!!")));
};

export default withRouter(RecommendationTable);